import { type CareServiceCareVolumeDto } from '@pflegix/types';
import { getLatestValidVolume } from './get-latest-valid-volume.util';

/**
 * Calculates the duration from the latest valid volume in the given array of volumes.
 * @param volumes - An array of CareServiceCareVolumeDto objects representing volumes.
 * @returns The duration of the latest valid volume, or undefined if no valid volume is found.
 */
export function getDurationFromLatestValidVolume(volumes: CareServiceCareVolumeDto[]): number | undefined {
  return getLatestValidVolume(volumes)?.volumeDuration;
}
